"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterTypeInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const types_1 = require("@framework/types");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const ParameterTypeInput = (props) => {
    const { name = "parameterType" } = props;
    return (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: name, options: types_1.ParameterType });
};
exports.ParameterTypeInput = ParameterTypeInput;
//# sourceMappingURL=index.js.map